import { createBankLine, explainAsEntity } from './bankService';
import { appendPostingSet } from './ledgerService';

// Company that receives subscription charges and pays the vendor cost
export const SUBSCRIPTION_COMPANY_NAME = 'UCENA LLC';

export const findSubscriptionCompany = (entities = []) =>
  entities.find((e) =>
    e?.entityType === 'company' &&
    String(e.entityName || '').trim().toLowerCase() === SUBSCRIPTION_COMPANY_NAME.toLowerCase()
  ) || null;

/**
 * Posts a subscription renewal to banking + ledger, in order:
 *  1. Bank transaction for the Charge, explained as Entity › Company › UCENA LLC (creates its ledger entry)
 *  2. Only then: Cost moved from UCENA LLC to the vendor (−Cost company, +Cost vendor) as one posting set
 */
export const postSubscriptionRenewal = async ({
  subscription,
  companyEntity,
  vendorEntity,
  chargeUsd,
  costUsd,
  date,
  newExpiry,
  createdBy,
}) => {
  const termLabel = subscription.term === 'annual' ? 'Annual' : 'Monthly';
  const serviceLabel = [subscription.serviceName, subscription.clientName].filter(Boolean).join(' — ');
  const description = `Subscription renewal: ${serviceLabel} (${termLabel}, until ${newExpiry})`;

  const bankLine = await createBankLine({
    date,
    amountUsd: chargeUsd,
    description,
    reference: `Subscription ${subscription.id}`,
    createdBy,
  });
  const chargeEntry = await explainAsEntity({
    bankLineId: bankLine.id,
    directAccountType: 'company',
    directAccountId: companyEntity.id,
    amountUsd: chargeUsd,
    description,
    explainedBy: createdBy,
  });

  let costLedgerEntryIds = [];
  if (costUsd > 0) {
    const memo = `Subscription vendor cost: ${subscription.serviceName || 'Service'} — ${vendorEntity.entityName} (${subscription.clientName || 'client'}, until ${newExpiry})`;
    costLedgerEntryIds = await appendPostingSet(
      [
        { amountUsd: -costUsd, directAccountType: 'company', directAccountId: companyEntity.id },
        { amountUsd: costUsd, directAccountType: vendorEntity.entityType || 'vendor', directAccountId: vendorEntity.id },
      ],
      {
        postedAt: date,
        source: 'Subscription',
        eventType: 'Subscription',
        memo,
        serviceId: subscription.serviceId || null,
        serviceName: subscription.serviceName || '',
        bankLineId: bankLine.id,
        createdBy,
      }
    );
  }

  return { bankLineId: bankLine.id, chargeLedgerEntryId: chargeEntry.id, costLedgerEntryIds };
};
